<template>
    <Modal
        modalName="Intersect" 
        title="Intersect"
        :buttons="['continue', 'cancel']" 
    >
    <div id="SelectsWrapper">
        <v-select
            :items="operacje"
            item-text="name"
            :return-object="true"
            label="Wybierz zależność"
        />
        <v-select 
            :items="layers"
            item-text="name"
            :return-object="true" 
            label="Podaj nazwę warstwy"
        />
        <v-select 
            :items="wynik"
            item-text="name"
            :return-object="true"
            label="Wynik"
        />
    </div>
    </Modal>
</template>

<script>
    import Modal from '../../../shared/Modal';

    export default {
        components: {
            Modal
        },
        data: () => ({
            wynik: [
                {
                    name: "Selekcja"
                },
                {
                    name: "Nowa warstwa"
                }
            ],
            operacje: [
                {
                    name: "Przecina się"
                },
                {
                    name: "Zawiera się"
                }
            ]
        }),
        computed: {
            layers() {
                return this.$store.getters.getLayers
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/Intersect.vue